import { render } from "./HomeView.vue?vue&type=template&id=5a3c2d5b&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=5a3c2d5b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\katsuta\\Documents\\AiGlies\\node\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3c2d5b"]])

export default __exports__